import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  scroll-snap-align: start;

  @media (screen-spanning: single-fold-vertical) {
    width: env(fold-left);
  }

  @media (horizontal-viewport-segments: 2) {
    width: env(viewport-segment-right 0 0);
  }
`;

export const ImageContainer = styled.div`
  overflow: hidden;
`;

const shouldForwardProp = () => true;

export const Image = styled('img').withConfig({ shouldForwardProp })`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

export const Text = styled.p`
  margin: var(--gap);
  margin-bottom: 0;
  font: inherit;
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
`;
